import React from 'react';
import { logError } from 'helpers/logger';
import InlineError from './index';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    logError(this.props.context || 'Form crashed', error, {
      componentStack: errorInfo?.componentStack
    });
  }

  render() {
    if (this.state.error) {
      return (
        <InlineError
          error={{
            message:
              this.props.message ||
              'Something went wrong rendering this form. The details were written to the browser console.'
          }}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
